import type { FaireProductEntity } from "../../entity_types/product";

export const p_9q9fjnmkhh: FaireProductEntity = {
  token: "p_9q9fjnmkhh",
  type: "product",
  name: "Orangina Carbonated Orange Drink 250ml - 4x6pck (European)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/1d7ab70c1c3188a8b3df0a399551b75897e6e59310c08e317018de7317df4b4f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c86ce25ae48d3ee9c6292662057756f9837f821a420980ee534d33bf19e5c87b.jpeg",
  ],
  priceDollars: 2.99,
  description:
    "Orangina Carbonated Orange Drink – Refreshing, Citrusy & Lightly Sparkling (European Classic) 🍊🥤🇪🇺\n\nEnjoy a timeless European favorite with Orangina Carbonated Orange Drink, a lightly sparkling beverage made with real orange juice and natural citrus pulp. Known for its distinctive taste and iconic bottle, Orangina delivers a refreshing balance of sweetness and tanginess in every sip.\n\nUnlike standard sodas, Orangina features real fruit pulp suspended in a lightly carbonated base, giving it a more natural and refreshing feel. The drink is typically shaken before opening to evenly distribute the pulp, enhancing the full citrus flavor experience.\n\nThis convenient 4×6 pack (24 bottles total) is perfect for stocking up, sharing, or serving at gatherings.\n\nWhat to expect:\n\n * Lightly carbonated orange drink \n * Made with real citrus juice and pulp \n * Refreshing sweet and tangy flavor \n * Signature European soda experience \n * Multipack with 24 × 250ml bottles \nPerfect for everyday refreshment, parties, or anyone who enjoys classic European soft drinks with a natural fruit twist.\n\nSize: 250ml per bottle (24 bottles total)\nAllergens: Typically none listed; check packaging for full details.\n\n✨ Light, citrusy, and refreshingly unique—Orangina (Europe) delivers a classic sparkling orange experience with real fruit pulp in every bottle.\n",
  tags: [],
  msrpDollars: 5.53,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:08.586Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
